import { FunctionComponent, useState, useEffect } from 'react';
import { LabourAssignedByTaskBarcode } from '../../types/tasks';
import crewPlanApi from './../../api/crewPlan';
import { Typography, Paper, LinearProgress, Switch, Tabs } from '../../tailwindcomponents';
import LineWorkpackageCard from "../Line/LineWorkpackageCard";
import PartDetails from '../../components/Parts/PartDetails';
import { LineWorkPackages } from './../../types/line';
import { MxiStaffManagementEmployee } from '../../types/staffManagement';
import TasksApi from "./../../api/tasks";
import { useSelector } from 'react-redux';
import { RootState } from './../../reducer';
import ProfileImg from '../../components/Images/ProfileImg';
import TaskNotesManager from '../HangarPlan/TaskNotesManager';
import { TaskNote } from '../../types/tasks';

interface CrewPlanDialogProps {
    selectedEvent: LineWorkPackages,
    myCrew: Array<MxiStaffManagementEmployee>
}

const CrewPlanDialog: FunctionComponent<CrewPlanDialogProps> = ({ selectedEvent, myCrew }) => {
    const [tabValue, setTabValue ] = useState<number>(0);
    const [assignedLabour, setAssignedLabour] = useState(Array<LabourAssignedByTaskBarcode>);
    const [taskNotes, setTaskNotes] = useState<TaskNote[]>([]);
    const [notesLoading, setNotesLoading] = useState(false);
    const [tabNames, setTabNames] = useState(["Task", "Action Notes (0)", "Parts(0)"]);
    const store = useSelector((state: RootState) => state);
    const users = store.employees.all_employees;
    const me = store.user.me;

    useEffect(() => {
        let isMounted = true;

        const loadDialogData = async () => {
            setNotesLoading(true);
            try {
                const [notesResponse, partsResponse] = await Promise.all([
                    TasksApi.GetTaskNotes(selectedEvent.task_barcode),
                    TasksApi.GetAllPartsByTaskBarcode(selectedEvent.task_barcode),
                ]);

                if (!isMounted) {
                    return;
                }

                const fetchedNotes = notesResponse.status ? notesResponse.data : [];
                const noteCount = fetchedNotes.filter(n => n.current_version && !n.is_deleted).length;
                const partCount = partsResponse.status === true ? partsResponse.data.length : 0;

                setTaskNotes(fetchedNotes);
                setTabNames(["Task", `Action Notes (${noteCount})`, `Parts (${partCount})`]);
            } catch (error) {
                if (!isMounted) {
                    return;
                }
                console.error('Error fetching crew plan dialog data:', error);
                setTaskNotes([]);
                setTabNames(prev => [prev[0], "Action Notes (0)", prev[2]]);
            } finally {
                if (isMounted) {
                    setNotesLoading(false);
                }
            }
        };

        loadDialogData();
        refreshAssignedLabour(selectedEvent.task_barcode);

        return () => {
            isMounted = false;
        };
    }, [selectedEvent.task_barcode]);

    const handleNotesUpdated = (updatedNotes: TaskNote[]) => {
        setTaskNotes(updatedNotes);
    };

    useEffect(() => {
        // Update tab name to reflect current note count
        const noteCount = taskNotes.filter(n => n.current_version && !n.is_deleted).length;
        setTabNames(prev => [prev[0], `Action Notes (${noteCount})`, prev[2]]);
    }, [taskNotes]);


    const refreshAssignedLabour = (barcode: string) => {
        crewPlanApi.GetLabourAssignedByTaskBarcode(barcode).then(res => {
            if (res.status) {
                setAssignedLabour(res.data);
            }
            else {
                setAssignedLabour([]);
            }
        })
    }
    const onChangeLabour = (user: MxiStaffManagementEmployee) => {
        crewPlanApi.ChangeLabour(selectedEvent.task_barcode, user.employee_id, selectedEvent.wo_barcode).then(res => {
            refreshAssignedLabour(selectedEvent.task_barcode);
        })
    }
    return (
        <div>
            <div>
                <Tabs variant="fullWidth" tabNames={tabNames} tabValue={tabValue} onChangeTabValue={(tabValue: number) => setTabValue(tabValue)} />
                {tabValue === 0 && <div>
                    <LineWorkpackageCard task={selectedEvent} type='BAY' onOpenDialogClicked={() => { }} />
                    <Typography text={`Labour(${assignedLabour.length})`} variant='h2' align='center' margin={[2, 0, 2, 0]} />
                    <div className="flex flex-wrap">
                        {myCrew.map((user, index) => (
                            <div className="w-1/3">
                                <Paper className="m-[3px]">
                                    <div className="flex flex-wrap w-full items-center">
                                        <div className="w-1/12 flex justify-center">
                                            <ProfileImg imgKey={index} imgSize="xs" userName={users?.find(s => s.Id === user.employee_id)?.userName?.split('@')[0]} />
                                        </div>
                                        <div className="w-3/4"><Typography text={user.employee_full_name} align='center' /></div>
                                        <div className="w-1/12"><Switch
                                            checked={assignedLabour.filter(s => s.employee_id === user.employee_id).length > 0}
                                            onChange={() => onChangeLabour(user)}
                                            color="secondary"
                                            name="checkedB"
                                        /></div>
                                    </div>
                                </Paper>
                            </div>
                        ))}
                    </div>
                </div>}
                {tabValue === 1 && <div>
                    {notesLoading ? (
                        <div>
                            <LinearProgress />
                            <Typography text="Loading task notes..." margin={[1, 0, 0, 0]} />
                        </div>
                    ) : (
                        <TaskNotesManager
                            taskBarcode={selectedEvent.task_barcode}
                            taskName={selectedEvent.task_name || 'Task'}
                            notes={taskNotes}
                            currentUserId={me.user_id}
                            onNotesUpdated={handleNotesUpdated}
                        />
                    )}
                </div>}
                {tabValue === 2 &&
                    <PartDetails taskBarcode={selectedEvent?.task_barcode} />
                }
            </div>
        </div>
    );
}
export default CrewPlanDialog;